import { render, staticRenderFns } from "./CommuneField.vue?vue&type=template&id=06450ec5&"
import script from "./CommuneField.vue?vue&type=script&lang=js&"
export * from "./CommuneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports